import { css } from '@emotion/react'
import styled from '@emotion/styled'
import makeStyles from '@mui/styles/makeStyles'
import { Paper } from '@components'

export const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '100%',
    height: '100%',
  },
}))

export const TitleContainer = styled.div`
  padding: 32px 44px 42px 44px;
`

export const Container = styled(Paper)`
  padding: 24px 32px;
  overflow: hidden;
  height: 100%;
  border-radius: 0;
`

export const Row = styled.div`
  margin: 10px 16px 32px;
`

export const NoBMarginRow = styled.div`
  margin: 10px 16px 0px;
`

export const NoTMarginRow = styled.div`
  margin: 0px 16px 32px;
`

export const ImageRow = styled.div`
  display: flex;
  margin: 10px 16px 32px;

  > div {
    margin-left: 20px;
  }
`

export const InputContainer = styled.div`
  display: flex;
  width: 50%;
`

export const ChangeImageButton = styled.button`
  position: relative;
  width: 150px;
  height: 150px;
  margin: 0;
  padding: 0;
  border: none;
  cursor: pointer;
`

export const LogoOverlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 33%;
  padding-top: 15px;
  background: rgba(0, 0, 0, 0.4);
  color: white;
  font-weight: 600;
`

export const input = css`
  margin-right: 15px;
`
